import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('top');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const sections = navLinks
      .map((l) => document.getElementById(l.id))
      .filter((el): el is HTMLElement => Boolean(el));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px', threshold: 0 },
    );
    sections.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleLink = () => setMenuOpen(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-50/95 backdrop-blur border-b border-foreground-950/10'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-10" aria-label="主导航">
        <a href="#top" onClick={handleLink} className="flex items-center gap-2.5 shrink-0 group">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-lg font-bold transition-transform group-hover:-rotate-6">
            瓜
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-heading text-lg font-bold tracking-wide transition-colors ${scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'}`}>
              美日吃瓜
            </span>
            <span className={`mt-0.5 text-[10px] tracking-[0.28em] transition-colors ${scrolled || menuOpen ? 'text-foreground-500' : 'text-background-200'}`}>
              异国社会观察
            </span>
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={`relative block rounded-md px-3 py-2 text-sm transition-colors ${
                  active === link.id
                    ? 'text-primary-600'
                    : scrolled
                      ? 'text-foreground-700 hover:text-foreground-950'
                      : 'text-background-100 hover:text-background-50'
                }`}
              >
                {link.label}
                {active === link.id && (
                  <span className="absolute inset-x-3 -bottom-0.5 h-0.5 rounded-full bg-primary-500" />
                )}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#subscription"
            className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 text-foreground-950 hover:bg-background-100'
            }`}
          >
            订阅更新
          </a>
        </div>

        <button
          type="button"
          aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden flex h-10 w-10 items-center justify-center rounded-md text-2xl transition-colors ${
            scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'
          }`}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden border-t border-foreground-950/10 bg-background-50 px-4 pb-5 pt-2">
          <ul className="flex flex-col">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={handleLink}
                  className="block rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#subscription"
            onClick={handleLink}
            className="mt-2 block whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅更新
          </a>
        </div>
      )}
    </header>
  );
}